import React from 'react'
import { Link } from 'react-router-dom'

import Option from './option';

class SimpleOptionsList extends React.Component {
  get renderOptions() {
    return this.props.collection.map((item, index) => {
      return (
        <Option key={index}
                item={item}
                onSelect={this.props.onSelect}
                selected={this.props.selectedItems}
        />
      );
    });
  }

  get renderDummy() {
    return (
      [<li key="d1" className="simple-options-list-item-dummy" />,
       <li key="d2" className="simple-options-list-item-dummy" />,
       <li key="d3" className="simple-options-list-item-dummy" />,
       <li key="d4" className="simple-options-list-item-dummy" />]
    );
  }

  render() {
    return (
      <ul className={`construction-types-list ${this.props.collection.length > 1 ? 'with-images' : ''}`}>
        { this.renderOptions }
        { this.renderDummy }
      </ul>
    )
  }
}

export default SimpleOptionsList;


// WEBPACK FOOTER //
// ./app/javascript/app/components/simple_options_list/index.jsx